import { EdgeLoadProSubscriptionRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadProSubscription } from '@/modules/auth/use-cases'

export function makeLoadProSubscription(): LoadProSubscription {
  return new EdgeLoadProSubscriptionRepository(makeSupabaseEdgeHttpClient()).execute
}
